import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const UserItem = ({ user: { login, avatar_url } }) => {
  return (
    <Link to={`/user/${login}`} style={{ textDecoration: "none" }}>
      <div className="user-card">
        <img src={avatar_url} alt={login} />
        <div className="user-card-info">
          <h3>{login}</h3>
        </div>
      </div>
    </Link>
  );
};

UserItem.propTypes = {
  user: PropTypes.object.isRequired,
};

export default UserItem;
